import { render } from "./TopBlogsSection.vue?vue&type=template&id=2f37a6e3&scoped=true"
import script from "./TopBlogsSection.vue?vue&type=script&lang=js"
export * from "./TopBlogsSection.vue?vue&type=script&lang=js"

import "./TopBlogsSection.vue?vue&type=style&index=0&id=2f37a6e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f37a6e3"]])

export default __exports__